{
  "FRONTEND": {
    "MEETING_INTEGRATIONS": {
      "COMMON": {
        "OTHER": "Other",
        "OTHERS": "Others",
        "CANCEL": "Cancel",
        "CONFIRM": "Confirm",
        "BACK": "Back",
        "PASSWORD": "Password"
      },
      "ATTENDEE_SELECTION_DIALOG": {
        "ATTENDEES": "Contacts",
        "SELECT_ATTENDEES": "Select contacts",
        "EMAIL_ONLY": "Only contacts with email addresses will appear",
        "TRACKING_ONLY_WARNING": "Choosing a contact is currently only for tracking purposes. You will need to send your prospect the meeting link from the next screen.",
        "CREATE_ATTENDEE": "Create contact",
        "CREATE_MEETING": "Create meeting",
        "NO_ATTENDEE_SELECTIONS": "This account has no contacts with email addresses",
        "AT_LEAST_ONE_ATTENDEE_REQUIRED": "At least one attendee must be selected",
        "PEOPLE_IN_MEETING_CONFIRMATION": "You will need to send the meeting link from the next screen to the following people",
        "CREATE_MEETING_ERROR": "There was an issue creating a meeting"
      },
      "INSTANT_MEETING_DIALOG": {
        "MEETING_INFORMATION": "Meeting information",
        "JOIN_MEETING_URL": "Join meeting URL",
        "TEXT_COPIED": "Copied text to clipboard",
        "START_MEETING": "Start meeting",
        "CANNOT_START_MEETING": "Cannot start meeting"
      },
      "REDIRECT_TO_AUTH_DIALOG": {
        "ONE_MORE_STEP_TO_AUTHORIZE": "Just one more step is required for your first meeting",
        "GO_TO_AUTHORIZATION_PAGE": "Please to go the authorization page and connect/authorize your account",
        "GO_TO_AUTHORIZATION_PAGE_NOW": "Go to authorization page now",
        "REDIRECT_ERROR": "There was a problem navigating to the authorization page"
      },
      "ENABLE_AUTO-GENERATE_MEETINGS_DIALOG": {
        "UNABLE_TO_GENERATE_MEETING_ID": "There was a problem generating your Google Meet video conference ID",
        "GMAIL_CALENDAR_SETTING_NEEDS_TO_BE_ENABLED": "You will need to have automatically-created meetings enabled in your Google Calendar settings.",
        "STEPS_TO_ENABLE": "Open Google Calendar settings and enable the following setting:",
        "SETTING_TO_ENABLE": "Automatically add Google Meet video conferences to events I create",
        "LINK_TO_RESOURCE_ON_HOW_TO_ENABLE": "More information on this setting can be found here",
        "GOOGLE_CALENDAR_SETTINGS": "Google Calendar settings"
      },
      "CONNECT_TO_SERVICE_ELEMENT": {
        "CONNECT_SERVICE": "Connect service",
        "DISCONNECT_SERVICE": "Disconnect service"
      },
      "CONNECTION_STATUS_ELEMENT": {
        "SERVICE_NOT_CONNECTED": "Service not connected",
        "SERVICE_CONNECTED": "Service connected"
      }
    }
  }
}
